function throttle (fn, delay) {
  var now, lastExec, timer, context, args;

  var execute = function () {
    fn.apply(context, args);
    lastExec = now;
  };

  return function () {
    context = this;
    args = arguments;

    now = Date.now();

    if (timer) {
        clearTimeout(timer);
        timer = null;
    }

    if (lastExec) {
        var diff = delay - (now - lastExec);
        if (diff < 0) {
            execute();
        } else {
            timer = setTimeout(function () {
                execute();
            }, diff);
        }
    } else {
        execute();
    }
  };
}

function triggerEvent(element, event) {
  var evt;

  if (document.createEvent) {
    evt = document.createEvent('HTMLEvents');
    evt.initEvent(event, true, true); // event type, bubbling, cancelable
    return element.dispatchEvent(evt);
  } else {
    // IE
    evt = document.createEventObject();
    return element.fireEvent('on' + event, evt)
  }
}

export default {
  doCheck: function (e) {
    if((this.scrollEventTarget.getBoundingClientRect().top + this.options.offset) > (window.innerHeight * 0.7)) {
      return;
    }

    this.scrollEventTarget.classList.add('is-view');
  },
  bind: function (el, bindings, vnode) {
    /**
     * 既にbindされている場合はスキップ
     */
    if(bindings.fadeinBinded) return;
    bindings.fadeinBinded = true;

    /**
     * optionを設定
     */
    const v = bindings.value || {};
    bindings.options = {
      offset: v.offset || 0
    };

    bindings.scrollEventTarget = el;
    bindings.scrollListener = throttle(bindings.def.doCheck.bind(bindings), 200)
    window.addEventListener('scroll', bindings.scrollListener)

    vnode.context.$nextTick(() => {
      triggerEvent(window, 'scroll')
    })
  },
  update: function (el, bindings) {
  },
  unbind: function (el, bindings) {
    window.removeEventListener('scroll', bindings.scrollListener, false)
  }
}


// WEBPACK FOOTER //
// ./src/plugins/vue-inview/directive.js